import { PaginatedResponse } from '@/types/api';

import { TClip } from '../types';

export const CLIPS_PAGE_SIZE = 25;

/**
 * Asks a cut list endpoint, the programme's or the segment's, for every cut it holds in one
 * request: a broadcast holds far fewer than this. Readers of the same whole list share it, so
 * they share one cache entry.
 */
export const WHOLE_CUT_LIST_FILTERS = { rowsPerPage: 500, offset: 0 };

export type ClipsPage = PaginatedResponse<TClip, undefined>;

/**
 * Next offset for an infinite clip list, or `undefined` when the server has nothing left.
 *
 * Pages keep the endpoint's `{ data, total }` shape because the panel header states the
 * server-side total. Cache writers under the `['clips', …]` prefix must handle both this
 * shape and the flat pages `useInfiniteClips` still produces.
 */
export function getNextClipsOffset(lastPage: ClipsPage, allPages: ClipsPage[]) {
  if (lastPage.data.length < CLIPS_PAGE_SIZE) return undefined;

  const loaded = allPages.reduce((count, page) => count + page.data.length, 0);
  if (loaded >= lastPage.total) return undefined;

  return loaded;
}
